import * as React from "react";
const SvgFiRrFaceSmileTear = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-smile-tear_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m-.014-4.92a1 1 0 0 1-1.151.821c-2.539-.424-4.423-2.085-4.501-2.156a1 1 0 0 1 1.33-1.494c.016.014 1.547 1.351 3.5 1.677a1 1 0 0 1 .822 1.152M14 9.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 14 9.5m-7 0a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 9.5m9.462 3.112C17.053 13.303 18 14.878 18 16a2 2 0 1 1-4 0c0-1.097.952-2.686 1.542-3.385a.603.603 0 0 1 .92-.003"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-smile-tear_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSmileTear;
